import { jsx as _jsx } from "react/jsx-runtime";
import { identity } from 'es-toolkit';
import { default as memoizeOne } from 'memoize-one';
import { useMemo } from 'react';
// @ts-ignore
import shallowEqual from 'shallowequal';
/**
 * The provider accepts context values as props, not just single value prop.
 * All props are combined into context value using shallow-equal memoization.
 * So instead <Provider value={{propA:1, propB:2, propC:3}}>...
 * you can use
 * <Provider propA={1} propB={2} propC={3}/>
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const createPropsContextProvider = (context) => {
    const Provider = ({ children, ...rest }) => {
        const getMemoizedValue = useMemo(() => memoizeOne(identity, ([oldValue], [newValue]) => shallowEqual(oldValue, newValue)), []);
        return (_jsx(context.Provider, { value: getMemoizedValue(rest), children: children }));
    };
    return Provider;
};
